/* src/app/_shared/components/input/input.component.scss */
:host {
  --width: 100%;
  --hight: unset;
  --input-border-color: var(--ion-color-medium);
  --input-placeholder-color: var(--ion-color-medium);
  --input-placeholder-weight: unset;
  --input-placeholder-size: unset;
  display: block;
  width: var(--width);
}
:host.ng-invalid.ng-touched .flow-input label {
  color: var(--ion-color-danger);
}
:host.ng-invalid.ng-touched .flow-input .input-container input {
  border-color: var(--ion-color-danger);
}
:host.ng-invalid.ng-touched .flow-input .input-container input:active,
:host.ng-invalid.ng-touched .flow-input .input-container input:focus,
:host.ng-invalid.ng-touched .flow-input .input-container input:hover {
  border-color: var(--ion-color-danger);
}
.flow-input {
  width: var(--width);
}
.flow-input label {
  display: block;
  margin: var(--input-label-margin);
  font-size: var(--input-label-font-size);
}
.flow-input .input-container {
  position: relative;
  width: var(--width);
}
.flow-input .input-container ion-icon {
  display: inline-block;
  position: absolute;
  right: var(--input-icon-position-right);
  top: var(--input-icon-position-top);
  font-size: var(--icon-size);
  color: var(--ion-color-medium-shade);
  font-weight: bold;
  transition: color 0.2s;
}
.flow-input .input-container input {
  -webkit-appearance: none;
  display: block;
  width: var(--width);
  height: var(--hight);
  padding: var(--input-padding);
  border: 1px solid var(--input-border-color);
  border-radius: var(--radius);
  background-color: #FFFFFF;
  color: #444444;
  font-family: var(--font-family);
  font-size: var(--input-font-size);
  box-shadow: none;
  transition: border-color 0.2s;
}
.flow-input .input-container input.icon {
  padding: var(--input-padding-icon);
}
.flow-input .input-container input[disabled] {
  border-color: var(--input-border-color);
  color: var(--ion-color-medium);
}
.flow-input .input-container input[disabled] + ion-icon {
  color: var(--ion-color-medium);
}
.flow-input .input-container input:not(:disabled):active,
.flow-input .input-container input:not(:disabled):focus,
.flow-input .input-container input:not(:disabled):hover {
  border-color: var(--ion-color-primary);
  outline: none;
}
.flow-input .input-container input:not(:disabled):active:read-only,
.flow-input .input-container input:not(:disabled):focus:read-only,
.flow-input .input-container input:not(:disabled):hover:read-only {
  border-color: var(--ion-color-primary);
}
.flow-input .input-container input:not(:disabled):active:read-only + ion-icon,
.flow-input .input-container input:not(:disabled):focus:read-only + ion-icon,
.flow-input .input-container input:not(:disabled):hover:read-only + ion-icon {
  color: var(--ion-color-primary);
}
.flow-input .input-container input:not(:disabled):active + ion-icon,
.flow-input .input-container input:not(:disabled):focus + ion-icon,
.flow-input .input-container input:not(:disabled):hover + ion-icon {
  color: var(--ion-color-primary);
}
.flow-input .input-container input::placeholder {
  color: var(--input-placeholder-color);
  font-weight: var(--input-placeholder-weight);
  font-size: var(--input-placeholder-size);
}
/*# sourceMappingURL=input.component-QJMVBKKG.css.map */
